var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoLung(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0) ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6553 6.27114C7.76158 6.26107 7.86839 6.25962 7.97463 6.26626C8.13347 6.27618 8.29115 6.30475 8.44436 6.35122C9.25371 6.59679 9.8986 7.33175 9.95217 8.33461L10.4248 17.193C10.4873 18.3679 9.63361 19.3923 8.46682 19.5436L3.78909 20.15C3.62554 20.1712 3.46146 20.1739 3.30081 20.1588C2.17617 20.0535 1.19626 19.0972 1.39748 17.8112C2.00039 13.9581 4.33386 9.88509 6.11233 7.22133C6.50357 6.6356 7.07226 6.32638 7.6553 6.27114Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5547 6.35122C16.3725 6.10325 17.3176 6.36917 17.8867 7.22133C19.6652 9.8851 21.9987 13.9581 22.6016 17.8112C22.8316 19.2809 21.5184 20.3196 20.21 20.15L15.5323 19.5436C14.3654 19.3924 13.5117 18.3679 13.5742 17.193L14.0459 8.33461C14.0995 7.33173 14.7454 6.5968 15.5547 6.35122Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2507 3.625C11.2507 3.21086 11.5866 2.87509 12.0007 2.875C12.4147 2.87517 12.7506 3.21094 12.7507 3.625V10.6367L16.8796 14.2285L16.9353 14.2822C17.1951 14.5595 17.2077 14.9943 16.9529 15.2871C16.6981 15.5797 16.2662 15.627 15.9558 15.4082L15.8953 15.3604L12.0017 11.9727L8.10912 15.3604C7.79674 15.6321 7.32343 15.5993 7.05151 15.2871C6.77961 14.9746 6.81226 14.5004 7.12475 14.2285L11.2507 10.6367V3.625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoLung);
export default __webpack_public_path__ + "static/media/DuoLung.7ffdfd2e27d09dbb008e6e160a027b4e.svg";
export { ForwardRef as ReactComponent };